import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { AuthService } from 'src/app/shared/auth/auth.service';
import { URLConst } from 'src/app/shared/const/url.const';
import { EnvironmentconfigService } from '../../../service/environmentconfig.service';
import { WebApiService } from 'src/app/shared/service/webapi.service';
import { NzMessageService } from 'ng-zorro-antd/message';
import { WmsmStatementQueryComponent } from 'src/app/WMSM-Pages/wmsm-StatementQuery/wmsm-StatementQuery.component';
import { WmsmStatementMaintainComponent } from 'src/app/WMSM-Pages/wmsm-StatementMaintain/wmsm-StatementMaintain.component';
import { WmsmStatementabnormalComponent } from 'src/app/WMSM-Pages/wmsm-Statementabnormal/wmsm-Statementabnormal.component';
import { TranslateService } from '@ngx-translate/core';
interface SiteDto {
  site: string;
  // 其他属性...
}
@Component({
  selector: 'app-wmsm-Rtconditions',
  templateUrl: './wmsm-Rtconditions.component.html',
  styleUrls: ['./wmsm-Rtconditions.component.scss'],
})
export class WmsmRtConditionsComponent implements OnInit {
  validateForm: FormGroup;
  SiteList: any;
  VendorList: any;
  list: any;
  BuyerList: any;
  DeptList: any;
  UserRequestlimits: boolean = true;
  dateFormat = 'yyyy/MM/dd';
  VendorInput: string;
  VendorOptionList = [];
  userOptionList = [];
  //從外部輸入
  @Input() QueryFromRT: string;

  //监听条件区数值改变，改变则往下传值
  @Output() listenForm = new EventEmitter();
  //实现查询时/点击时，条件区小三角形收缩
  @Input() isShowCondition: boolean;
  //user的权限控制
  @Input() show: boolean;
  //实现查询时/点击时，条件区小三角形收缩
  @Output() outQuery = new EventEmitter();
  loading: boolean = false;
  All: any;
  //按需求控制三个条件区是否需要显示
  @Input() ShowSite: boolean = true;
  @Input() ShowVendor: boolean = true;
  @Input() ShowBuyer: boolean = true;
  @Input() ShowRNO: boolean = true;
  @Input() ShowPONO: boolean = true;
  @Input() ShowPANo: boolean = true;
  @Input() ShowTime: boolean = true;
  @Input() ShowBillingStatus: boolean = true;
  @Input() ShowAutopaNo: boolean = false;
  constructor(
    private fb: FormBuilder,
    private AuthService: AuthService,
    private EnvironmentconfigService: EnvironmentconfigService,
    private WebApiService: WebApiService,
    private NzMessageService: NzMessageService,
    private StatementQuery: WmsmStatementQueryComponent,
    private StatementMaintain: WmsmStatementMaintainComponent,
    private Statementabnormal: WmsmStatementabnormalComponent,
    private translate: TranslateService

  ) { }

  ngOnInit() {
    this.validateForm = this.fb.group({
      Site: [''],
      Vendor: [[]],
      PONO: [''],
      StatementMonth: [''],
      InvoiceNo: [''],
      BillingStatus: [''],
      RNO: [''],
      PANo: [''],
      AutoPaNo: [''],
      Buyer: [[]],
    });
    this.GetCondition();
  }


  valuehandleChange(): void {
    // var sitecode = this.validateForm.controls['Site'].value;
    let value = {};
    Object.keys(this.validateForm.controls).forEach((key) => {

      if (key === 'Site') {
        value[key] = this.validateForm.controls[key].value
        // this.VendorList= this.list.filter(s => s.site == sitecode);
      }
      else {
        value[key] = this.validateForm.controls[key].value;
      }
    });
    this.listenForm.emit(value);
  }


  GetCondition(): Promise<void> {
    this.loading = true;
    const url = `${this.EnvironmentconfigService.authConfig.wmsmUrl}${URLConst.GetRtCondtion.url}`
    return new Promise((resolve, reject) => {
      this.WebApiService.doGet(url).subscribe((res) => {
        if (res.data.siteList.length != 0) {

          this.list = res.data.vendorList;
          this.VendorList = res.data.vendorList;
          this.SiteList = res.data.siteList.sort(this.compare);
          //this.validateForm.controls['Site'].setValue(this.SiteList[0].site);
          // this.validateForm.controls['Vendor'].setValue(['ALL']);
          this.ShowVendor = res.data.showVendorList;
          this.valuehandleChange();
          this.loading = false;
          resolve();
        } else {
          this.translate.get('TemporaryUnconditionalZoneInformation').subscribe((translatedText: string) => {
            this.NzMessageService.error(translatedText);
          })
          //  this.NzMessageService.error("暫無條件區信息");
          this.loading = false;
          reject()
        }

        const today = new Date();
        const threeMonthFromToday = new Date(today.getFullYear(), today.getMonth() - 3, today.getDate());
        this.validateForm.controls['StatementMonth'].setValue([threeMonthFromToday, today]);
      }

      );
    })

  }

  onPageChangeQuery() {
    if (this.QueryFromRT == 'StatementQuery') {
      this.StatementQuery.onSearch();
    }
    if (this.QueryFromRT == "StatementMaintain") {
      this.StatementMaintain.onSearch();
    }
    if (this.QueryFromRT == "Statementabnormal") {
      this.Statementabnormal.onSearch();
    }
  }


  onPageChangeDownload() {
    if (this.QueryFromRT == 'StatementQuery') {
      this.StatementQuery.exportTableToExecl();
    }
    if (this.QueryFromRT == "StatementMaintain") {
      this.StatementMaintain.exportTableToExecl();
    }
    if (this.QueryFromRT == "Statementabnormal") {
      this.Statementabnormal.exportTableToExecl();
    }
  }

  VendorSearch(event) {
    //this.loading=true

    if (event.length > 1) {
      const params = {
        Inputdata: event,
        SiteNo: this.validateForm.controls['Site'].value
      };
      const url = `${this.EnvironmentconfigService.authConfig.wmsmUrl}${URLConst.GetVendorListAsync.url}`;
      this.WebApiService.doPost(url, params).subscribe(
        (res) => {
          this.VendorOptionList = res
        },
        (error) => {
          this.NzMessageService.error(error.msg);
        }
      );
    }
  }


  BuyerSearch(event) {
    if (event.length > 2) {
      const params = {
        Inputdata: event,
        SiteNo: this.validateForm.controls['Site'].value
      };
      const url = `${this.EnvironmentconfigService.authConfig.wmsmUrl}${URLConst.GetBuyerListAsync.url}`;
      this.WebApiService.doPost(url, params).subscribe(
        (res) => {
          this.BuyerList = res
        },
        (error) => {
          this.NzMessageService.error(error.msg);
        }
      );
    }
  }

  //获取采购
  userSearch(event) {
    this.loading = true
    event = event.trim().toUpperCase();
    if (event.length > 5) {
      const url = `${this.EnvironmentconfigService.authConfig.MVMBackEnd}${URLConst.QueryUser.url}` + event;
      setTimeout(() => {
        this.WebApiService.doGet(url).toPromise().then(
          (res) => {
            this.loading = true;
            this.userOptionList = res.data.slice(0, 10);
            this.loading = false
          },
          (error) => {
            this.NzMessageService.error(error.msg);
            this.loading = false
          }
        );
      }, 800);
    }
    this.loading = false
  }

  compare(a: SiteDto, b: SiteDto): number {
    const nameA = a.site.toUpperCase(); // 忽略大小写进行比较
    const nameB = b.site.toUpperCase();

    if (nameA < nameB) {
      return -1;  // a 在 b 前面
    }
    if (nameA > nameB) {
      return 1;  // a 在 b 后面
    }
    return 0;  // 名称相同
  }
}
